{
    "name": "Salsify",
    "binomial_name": "Tragopogon porrifolius",
    "common_names": [
        "salsify",
        "white salsify",
        "oyster plant",
        "vegetable oyster",
        "goats beard"
    ],
    "description": "Salsify, or white salsify, is a perennial plant grown as an annual for it's edible root and leaves. It does well in cool weather and is cultivated similarly to carrots and parsnips. It is similar to Black Salsify, but they are in different genera. Both plants are grown for their edible roots and cultivated like carrots and parsnips. Salsify's leaves look like a clump of coarse grass with starry pink to purple flowers. The greens and flowers can be used in salads. Flowers should be dead-headed to prevent the plant from becoming invasive. Salsify is less hearty than Black Salsify. It requires sandy loam soil to grow straight roots and can be grown in containers. The taproot has dirty-beige skin and resembles a large white carrot. It has an oyster-like taste that some consider more subtle than Black Salsify. It can be eaten boiled or mashed; skin is inedible and should be removed. Plants can stay in the ground until just before the soil freezes and roots can be stored in a root cellar through the winter. Take extra care not to break the roots while harvesting - damaged roots have a much shorter shelf life.",
    "sun_requirements": "Partial Sun",
    "sowing_method": "Direct seed outdoors, thin to 7cm",
    "spread": 0,
    "row_spacing": 0,
    "height": 120,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/salsify.avif"
}